import { signal } from '@angular/core';
import cloneDeep from 'lodash/cloneDeep';
import { TColumn } from './column.model';

const _sorting = signal<TColumn[]>([]);
export const sortingSignal = _sorting.asReadonly();

// GET

export const GET_SORTING = (): TColumn[] => _sorting();

// SET & MODIFY

export const SET_SORTING = (sorting: TColumn[]): void => {
  _sorting.set(sorting);
};

// CLEAR

export const CLEAR_SORTING = (): void => {
  _sorting.set([]);
};

export const REMOVE_SORT = (column: TColumn): void => {
  const next = _sorting().filter((_column) => _column.index !== column.index);

  next.forEach((_column, _index) => {
    _column.groupIndex = _index;
  });

  _sorting.set(next);
};

export const MOVE_SORT_COLUMN = (columnIndex, destinationIndex): void => {
  const current = _sorting();
  const column = cloneDeep(current[columnIndex]);
  const next = [...current];

  next.splice(columnIndex, 1);
  next.splice(destinationIndex, 0, column);

  next.forEach((_column, _index) => {
    _column.sortIndex = _index;
  });

  _sorting.set(next);
};
